import moment from 'moment';
import validator from 'validator';

const languges = validator.isAlphaLocales

export const isValidEmail = (email) => {
    
}
//export const isValidPhoneNumber = (phoneNumber) => {
//    return validator.isMobilePhone(phoneNumber)
//}

// Currently, we will just check if the phone number has between 7 and 15 digits
export const isValidPhoneNumber = (phoneNumber) => {
    const digits = String(phoneNumber || '').replace(/\D/g, '')
    return digits.length >= 7 && digits.length <= 15
}

export const isValidString = (string) => {
   
}

export const isValidPostalCode = (postalCode) => {
    return validator.isPostalCode(postalCode, 'any')
}

export const isValidVersion = (str) => {
    //checks if a string is a version in this format:  num.num.num - 1.0.0 / 10.100.1000
    const versionPattern = /^\d+\.\d+\.\d+$/;
    return versionPattern.test(str);
}


export const isPassedFromMidnight = (date) => {
    if (!date) {
      return true;
    }
    return moment().startOf('day').isAfter(date);
};
  